import { i18n } from '@lingui/core'
import { t, Trans } from '@lingui/macro'
import { Box, FormLabel, Typography } from '@mui/material'
import { setUserData } from 'app/redux/actions/UserActions'
import { saveContactByFlowParsed } from 'app/services/sfAuth/sfData/sfContact'
import { useFormikContext } from 'formik'
import { FC } from 'react'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { parseSFApiValueToTranslationId } from 'translation/translationUtils'
import { ResourcesDetailsButton, ResourcesDetailsLightButton } from '../resources/ResourcesDetailsCard/Button'
import { FirstLoginFlowFormikProps } from './index'
import { GoalOption } from './useGoalOption'

interface ConnectToOrganizationProps {
  goalOptions: GoalOption[]
}

export const ConnectToOrganization: FC<ConnectToOrganizationProps> = ({ goalOptions }) => {
  const user = useSelector((state: RootStateOrAny) => state.user)

  const {
    values, handleChange, handleBlur, setFieldValue, validateForm
  } = useFormikContext<FirstLoginFlowFormikProps>()

  const onClickConnect = async () => {
    setFieldValue('displayOrganizationConnectDialog', true)
  }

  const onClickNotNow = () => {
    const contactId = user?.userObject?.contactId || user?.contact?.contactId
    saveContactByFlowParsed({
      id: contactId,
      whatAreYouLookingFor: values.goal
    }).then(() => {
      setFieldValue('goal', '')
      setFieldValue('goalCompleted', false)
      dispatch(setUserData({
        ...user,
        contact: {
          ...user.contact,
          whatAreYouLookingFor: values.goal
        }
      }))
    }).catch(error => {
      console.error(error)
    })
  }

  const goal = values.goal

  const isGoalInOptions = goalOptions.some(option => option.value === goal)

  const dispatch = useDispatch()

  return (
    <>
      <FormLabel>
        <Trans>FIRST_LOGIN_FLOW_CONNECT_TO_ORGANIZATION_LABEL</Trans>
      </FormLabel>

      {!isGoalInOptions &&
        <Typography variant='body2' sx={{ color: '#333333', fontSize: '16px', fontWeight: 400 }}>
          <Trans>DO YOU WANT TO CONNECT {user.displayName} USER TO AN ORGANIZATION?</Trans>
        </Typography>}

      {isGoalInOptions &&
        <Typography variant='body2' sx={{ color: '#333333', fontSize: '16px', fontWeight: 400 }}>
          <Trans>USER_ACCOUNT {user.displayName} HAS_TO_BE_CONNECTED_TO_AN_ORGANIZATION_FOR_THE_FOLLOWING</Trans>
        </Typography>}

      {isGoalInOptions && goalOptions.map(option => {
        const label = i18n._(t`${parseSFApiValueToTranslationId(option.label)}`)
        return (
          <Typography
            key={option.value}
            variant='body2'
            sx={{ mt: '16px', color: '#333333', fontSize: '16px', fontWeight: option.value === goal ? 700 : 400 }}
          >
            {`- ${label}`}
          </Typography>
        )
      })}

      <Box sx={{ display: 'flex', gap: '16px', mt: '16px' }}>
        <ResourcesDetailsButton
          text={<Trans>FIRST_LOGIN_FLOW_CONNECT_TO_ORGANIZATION_BUTTON</Trans>}
          onClick={onClickConnect}
        />
        {values.goal &&
          <ResourcesDetailsLightButton
            text={<Trans>FIRST_LOGIN_FLOW_NOT_NOW_BUTTON</Trans>}
            onClick={onClickNotNow}
          />}
      </Box>
    </>
  )
}
